import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../../shared/ErrorHandler';

@Component({
  selector: 'app-claim-form',
  templateUrl: './claim-form.component.html',
  styleUrls: ['./claim-form.component.css']
})
export class ClaimFormComponent implements OnInit {
  title = "Claims";
  roleId: string;
  roleName:string;
  officeName:string;
  claimsList: any;
  data:any;

  constructor(private userService: UserService,private router : Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {
    // let x = window.location.href;
    // var n = x.lastIndexOf('/');
    // this.roleId = x.substring(n + 1);
    // this.GetAllClaimsForTheRole(this.roleId);
    this.route.params.subscribe(params =>{
      this.roleId = params['roleId']
      this.roleName = params['roleName']
      // this.officeName = params['officeName']
    });
    if (this.roleId != null && this.roleName != null) 
      this.GetAllClaimsForTheRole(this.roleId);
  }

  GetAllClaimsForTheRole(roleId) {
    document.getElementById('loader-spinner').style.display="block";
    this.userService.getAllClaimsForTheRole(roleId)
      .subscribe(
        (data) => {
          this.claimsList = data;
          document.getElementById('loader-spinner').style.display="none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
  }

  SaveClaims(claimsList) {
    document.getElementById('loader-spinner').style.display="block";
    this.data = this.userService.saveClaims(claimsList, this.roleId)
    this.data.subscribe(
      (response) => { 
       
        swal('','Success! Note: This changes will come into effect when the user log out and log in again.','success');
        this.router.navigate(['/home/claimslist']);
        document.getElementById('loader-spinner').style.display="none";
        
      },(error) => {
        document.getElementById('loader-spinner').style.display="none";
        if(error.status==401)

        this.errorHandler.HandlerError(error);
      });
  }

  changeCheckbox(menuPos, pagePos, claimPos) {
    for (let i = 0; i < this.claimsList.length; i++) {
      if (i == menuPos) {
        for (let j = 0; j < this.claimsList[i].KHB_PagesList.length; j++) {
          if (j == pagePos) {
            for (let k = 0; k < this.claimsList[i].KHB_PagesList[j].KHB_PageFunctionClaim.length; k++) {
              if (k == claimPos) {
                let val: boolean = null;
                if (this.claimsList[i].KHB_PagesList[j].KHB_PageFunctionClaim[k].ClaimValue == true)
                  val = false;
                else
                  val = true;
                this.claimsList[i].KHB_PagesList[j].KHB_PageFunctionClaim[k].ClaimValue = val;
              }
            }
          }
        }
      }
    }
  }

  //For sub menu functions

  changeCheckbox1(menuPos, pagePos, subpagepos, claimPos) {
    debugger;
    for (let i = 0; i < this.claimsList.length; i++) {
      if (i == menuPos) {
        for (let j = 0; j < this.claimsList[i].KHB_PagesList.length; j++) {
          if (j == pagePos) {
            
            for (let m = 0; m < this.claimsList[i].KHB_PagesList[j].KHB_SubPagesModels.length; m++) {
              if (m == subpagepos) {               
                for (let h = 0; h < this.claimsList[i].KHB_PagesList[j].KHB_SubPagesModels[m].ClaimsModels.length; h++) {
                  console.log('Length');
                  console.log(this.claimsList[i].KHB_PagesList[j].KHB_SubPagesModels[m].ClaimsModels.length);
                  if (h == claimPos) {
                    let val: boolean = null;
                    if (this.claimsList[i].KHB_PagesList[j].KHB_SubPagesModels[m].ClaimsModels[h].ClaimValue == true)
                      val = false;
                    else
                      val = true;
                    this.claimsList[i].KHB_PagesList[j].KHB_SubPagesModels[m].ClaimsModels[h].ClaimValue = val;
                  }
                }
              }
            }

          }
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/ultilities/claims/claims/claim-form/claim-form.component.ts